export const MyApplicationsPages = {
  ALTQUOTE: "altquote",
  APPLICATION_STATUS: "application-status",
  ASSETS_INCLUDED: "assets-included",
  ALTQUOTE_ASSETS_INCLUDED: "altquote-assets-included",
  PROPOSALS: "proposals",
  MY_APPLICATION_DOCS: "my-application-docs/",
};
